module.exports = __webpack_public_path__ + "img/logo.b67e4c08.png";